import type { CityConfig } from "../city-template/types";

export const leesburgVaConfig: CityConfig = {
  city: "Leesburg",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "leesburg-va",
  route: "/leesburg-va",
  title: "Emergency Passport Leesburg, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Leesburg, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Leesburg, Loudoun County, and the Dulles corridor. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Leesburg, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Loudoun County, Ashburn, or Sterling? We help Leesburg travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Leesburg%20Virginia%20historic%20downtown%20with%20charming%20brick%20buildings%20and%20the%20iconic%20Loudoun%20County%20courthouse%20on%20King%20Street%2C%20the%20W%20and%20OD%20trail%20running%20through%20the%20area%2C%20warm%20afternoon%20light%20with%20a%20classic%20small-town%20American%20main%20street%20aesthetic%2C%20visible%20historic%20district%20with%20the%20Old%20Town%20Hall%20and%20the%20Tally%20Ho%20Theater%2C%20scenic%20Loudoun%20County%20landscape%20with%20rolling%20Virginia%20hills%2C%20no%20people%20visible%2C%20professional%20photography%20showcasing%20the%20picturesque%20historic%20town%20in%20Loudoun%20County%2C%20Virginia&width=1800&height=700&seq=leesburg-va-hero-001&orientation=landscape",
  heroImageAlt: "Leesburg Virginia historic downtown with Loudoun County courthouse and charming brick main street",
  geoPosition: "39.1157;-77.5636",
  geoPlacename: "Leesburg, Virginia",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 45 miles southeast of Leesburg via Route 7 and the Dulles Toll Road",
  },
  nearbyCitiesZips: [
    { name: "Leesburg", zips: "20175, 20176, 20177, 20178" },
    { name: "Ashburn", zips: "20146, 20147, 20148, 20149" },
    { name: "Sterling", zips: "20163, 20164, 20165, 20166, 20167" },
    { name: "Purcellville", zips: "20132, 20134" },
    { name: "Round Hill", zips: "20141, 20142" },
    { name: "Hamilton", zips: "20158, 20159" },
    { name: "Waterford", zips: "20197" },
    { name: "Lovettsville", zips: "20180" },
    { name: "Middleburg", zips: "20117, 20118" },
    { name: "Herndon", zips: "20170, 20171, 20172" },
    { name: "Reston", zips: "20190, 20191, 20194, 20195, 20196" },
    { name: "Chantilly", zips: "20151, 20152, 20153" },
    { name: "Centreville", zips: "20120, 20121" },
    { name: "Manassas", zips: "20108, 20109, 20110, 20111, 20112, 20113" },
    { name: "Fairfax", zips: "22030, 22031, 22032, 22033, 22035, 22037, 22038, 22039" },
    { name: "Winchester", zips: "22601, 22602, 22603, 22604" },
    { name: "Fredericksburg", zips: "22401, 22402, 22404, 22405, 22406, 22407, 22408, 22412" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from Loudoun County" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Loudoun County Hub", desc: "Serving Leesburg, Ashburn, Sterling, and the Dulles corridor" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/virginia" },
    { name: "Ashburn VA passport services", route: "/ashburn-va" },
    { name: "Herndon VA passport services", route: "/herndon-va" },
    { name: "Reston VA passport services", route: "/reston-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Leesburg remotely via secure courier. We do not have a walk-in office in Leesburg — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Leesburg and Loudoun County travelers.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, Maryland 20814",
  fpcOfficeDistance: "Serving all of Leesburg and Loudoun County including Ashburn, Sterling, Purcellville, Hamilton, Round Hill, Waterford, and the greater Dulles corridor",
  serviceAreaIntro: "From the historic brick streets of downtown Leesburg to the modern developments of One Loudoun, from the rolling hills of the Loudoun Valley to the bustling tech corridors near Dulles Airport, from the vineyards of Purcellville to the quaint village of Waterford — Fast Passport Center serves every corner of Leesburg and Loudoun County. We regularly help travelers from Ashburn, Sterling, Purcellville, and Middleburg get their passports fast.",
  nearbyCitiesIntro: "We serve all Leesburg neighborhoods and Loudoun County including Ashburn, Sterling, Purcellville, Round Hill, Hamilton, Waterford, Lovettsville, and Middleburg.",
  howItWorksIntro: "Most Leesburg travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Leesburg travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Leesburg and Loudoun County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Leesburg? Here are the most common ones we hear from Loudoun County travelers.",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from Virginia Department of Health Vital Records. Online, mail, or in-person options available for Leesburg and Loudoun County residents.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Virginia Department of Health Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Loudoun County Circuit Court Clerk. Certified copies available for name changes and legal purposes.", url: "https://www.loudoun.gov/Clerk" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Loudoun County Circuit Court Clerk. Required for name change passport corrections.", url: "https://www.loudoun.gov/courts" },
  ],
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Leesburg international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer H.",
      location: "Leesburg, VA",
      rating: 5,
      text: "I needed an emergency passport for a business trip to London with only 5 days notice. Fast Passport Center had my passport in 3 days. I shipped from the UPS Store on Catoctin Circle and it was completely seamless. No need to drive to DC or wait in government lines.",
      service: "Emergency Passport",
    },
    {
      name: "Michael S.",
      location: "Ashburn, VA",
      rating: 5,
      text: "As an Ashburn resident, I was worried about finding expedited passport services close to home. Fast Passport Center made it incredibly easy. Everything was done online, and my renewal was back in 5 days. The convenience for Loudoun County families is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Laura T.",
      location: "Sterling, VA",
      rating: 5,
      text: "First passports for my two children before a family trip to Italy. Fast Passport Center handled all the parental consent requirements perfectly and had both passports in 6 days. For Sterling families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "Robert D.",
      location: "Leesburg, VA",
      rating: 5,
      text: "Lost my passport 3 days before a business trip to Singapore. I was in absolute panic. Fast Passport Center had a replacement in my hands in 48 hours. They saved my career and my international trip. Loudoun County professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "leesburg-va-1",
      name: "Leesburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15 Cornwall St NW",
      city: "Leesburg",
      state: "VA",
      zip: "20176",
      phone: "(703) 771-2624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Historic Downtown Leesburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Leesburg facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "leesburg-va-2",
      name: "Ashburn Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "44715 Prentice Dr",
      city: "Ashburn",
      state: "VA",
      zip: "20147",
      phone: "(703) 723-0704",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Ashburn, east of Leesburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves eastern Loudoun County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "leesburg-va-3",
      name: "Sterling Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "209 S Maple Ave",
      city: "Sterling",
      state: "VA",
      zip: "20164",
      phone: "(703) 430-5381",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Sterling, southeast of Leesburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Sterling and Cascades area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "leesburg-va-4",
      name: "Purcellville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "220 W Main St",
      city: "Purcellville",
      state: "VA",
      zip: "20132",
      phone: "(540) 338-7226",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Purcellville, west of Leesburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves western Loudoun County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "leesburg-va-5",
      name: "Loudoun County Clerk",
      type: "County Clerk",
      address: "1 Harrison St SE",
      city: "Leesburg",
      state: "VA",
      zip: "20175",
      phone: "(703) 777-0270",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Leesburg",
      website: "https://www.loudoun.gov/Clerk",
      websiteLabel: "Loudoun County Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
    {
      id: "leesburg-va-6",
      name: "Middleburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 E Marshall St",
      city: "Middleburg",
      state: "VA",
      zip: "20117",
      phone: "(540) 687-6311",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "Middleburg, south of Leesburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves the Middleburg area. Limited hours. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 45+ minute drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Leesburg photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Loudoun County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Leesburg applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Leesburg families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Leesburg travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Leesburg or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Leesburg address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Leesburg before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Leesburg for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from Loudoun County." },
    { q: "How fast can I renew my passport in Leesburg?", a: "Fast Passport Center offers fast passport renewal in Leesburg in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Leesburg?", a: "The nearest regional passport agency to Leesburg is the Washington Passport Agency, located approximately 45 miles southeast in downtown Washington, DC. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Leesburg." },
    { q: "Can I get a same-day passport appointment near Leesburg?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Leesburg residents." },
    { q: "Can I expedite a child passport in Leesburg?", a: "Yes. Fast Passport Center expedites child passports in Leesburg for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Loudoun County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Leesburg with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Leesburg?", a: "With Fast Passport Center's emergency courier service, Leesburg travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Leesburg?", a: "Popular options include the Leesburg Post Office (20176), Ashburn Post Office (20147), Sterling Post Office (20164), and Purcellville Post Office (20132). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Ashburn, Sterling, or Purcellville?", a: "We serve the entire Loudoun County area including Ashburn, Sterling, Purcellville, Hamilton, Round Hill, Waterford, and Lovettsville. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Leesburg?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Leesburg", address: "602 E Market St, Leesburg, VA 20176", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Leesburg", address: "1201 S King St, Leesburg, VA 20175", hours: "Mon-Sun: 7AM-11PM" },
    { name: "FedEx Office — Leesburg", address: "223 Catoctin Cir SE, Leesburg, VA 20175", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM" },
    { name: "CVS Pharmacy — Ashburn", address: "43980 Pipeline Plaza, Ashburn, VA 20147", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Sterling", address: "209 S Maple Ave, Sterling, VA 20164", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Purcellville", address: "571 E Main St, Purcellville, VA 20132", hours: "Mon-Sun: 8AM-10PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Leesburg",
      address: "945 Edwards Ferry Rd NE, Leesburg, VA 20176",
      hours: "Mon-Fri: 8AM-5PM, Sat: 8AM-12PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Ashburn",
      address: "21595 Smith Switch Rd, Ashburn, VA 20147",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Sterling",
      address: "46900 Cedar Lakes Plaza, Sterling, VA 20164",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Sterling and Cascades. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "Approximately 20 miles east of Leesburg",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "The closest international airport to Leesburg. Major international hub. Accessible via Route 7 and the Dulles Toll Road.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: true,
    },
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "Approximately 45 miles southeast of Leesburg",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Domestic hub near DC. Accessible via Route 7 and the GW Parkway.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore/Washington International Airport",
      distance: "Approximately 65 miles northeast of Leesburg",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Regional hub for Baltimore and DC area. Accessible via Route 7 and I-270.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport",
      featured: false,
    },
  ],
};